var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1179 3387 c-64 -34 -102 -93 -107 -166 -2 -32 1 -76 8 -97 10 -32 142 -169 679 -707 446 -447 679 -674 707 -687 50 -25 133 -26 182 -3 24 10 275 254 690 667 500 499 658 663 677 700 90 180 -92 368 -275 285 -34 -15 -180 -154 -613 -587 l-567 -567 -578 577 c-399 400 -588 582 -614 593 -56 23 -136 19 -189 -8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClDownArrow);
export default __webpack_public_path__ + "static/media/cl-down-arrow.0b4488b779af72cd33f26eaf06f6a85b.svg";
export { ForwardRef as ReactComponent };